import { get } from '../..';
import { DateRange } from '../../../redux/dateRangeSlice';

interface GetBookingsCountProps {
  range: DateRange,
  locationId: string,
}

const GetBookingsList = ({ range, locationId }: GetBookingsCountProps) => {
  let query: string = 'metrics/locations/bookings';
  query += `?locationId=${locationId}&from=${range.start}&to=${range.end}`;
  return get(query);
};

export default GetBookingsList;
